var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockDarkgrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f414a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.066 -0.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.5,11A5.5,5.5,0,1,1,11,5.5,5.506,5.506,0,0,1,5.5,11ZM5.38,6.2h0a.476.476,0,0,0,.119.015H8.369a.478.478,0,1,0,0-.957H5.739V1.913a.478.478,0,0,0-.957,0V5.739a.478.478,0,0,0,.478.478A.473.473,0,0,0,5.38,6.2Z",
    transform: "translate(0.066 0.379)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDarkgrey);
export default __webpack_public_path__ + "static/media/clock_darkgrey.6af2380eaefd30ccdb541d817cb3a526.svg";
export { ForwardRef as ReactComponent };